// /Users/boyd/Dev/freegopos/my-web-app/src/components/Footer.tsx
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaHistory, FaWhatsapp, FaBars, FaHome, FaFileInvoiceDollar } from 'react-icons/fa'; // Import icons
import { hasRole } from '../utils/auth'; // Assuming you have these auth utils
import { useConfig } from '../context/ConfigContext'; // Import useConfig
import { useTranslation } from 'react-i18next'; // Import useTranslation
import { isAuthenticated } from '../utils/auth';


// const Footer = ({ appConfig }: { appConfig: appConfig }) => {
const Footer = () => {
    const { t } = useTranslation(); // Initialize useTranslation
    const { settings, loadingSettings } = useConfig(); // Use settings from context

    const fqdn = 'https://' + window.location.hostname;  // Get the current host FQDN
    const [showBackToTop, setShowBackToTop] = useState(false);

    const isAdminOrStaff = hasRole(['super_admin', 'staff', 'technician']);

    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            const menu = menuRef.current;
            if (menu && !menu.contains(event.target as Node)) {
                menu.classList.add('hidden');
                menu.classList.remove('slide-in');
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const currentHost = window.location.hostname;
        if (loadingSettings || !settings || !settings.themes || typeof settings.themes.theme_name !== 'string') {
            return;
        }

        const version = window.APP_CONFIG?.CSS_VER || new Date().getTime();
        // console.log('Loading external CSS for theme:', settings.themes.theme_name, 'Version:', version);

        const externalCssUrl = `https://u8.my/excss/${settings.themes.theme_name}.css?v=${version}`;


        const productionDomains = ['localhost', '127.0.0.1', 'price.ka.my', 'next.ka.my', 't1.u8.my', 'sme.u8.my', 'thaisignature.u8.my', 'yeewah.u8.my', 'vektron.u8.my'];
        const developmentDomains = ['localhost', '127.0.0.1', 'price.ka.my', 'next.ka.my', 't1.u8.my', 'sme.u8.my', 'thaisignature.u8.my', 'yeewah.u8.my', 'vektron.u8.my'];

        // console.log('window.APP_CONFIG?.NODE_ENV, productionDomains, currentHost:', window.APP_CONFIG?.NODE_ENV, productionDomains, currentHost);

        if (window.APP_CONFIG?.NODE_ENV === 'development' && developmentDomains.includes(currentHost)) {
            loadExternalCss(externalCssUrl);
        } else if (window.APP_CONFIG?.NODE_ENV === 'production' && productionDomains.includes(currentHost)) {
            loadExternalCss(externalCssUrl);
        } else {
            loadExternalCss(externalCssUrl);
        }

    }, [settings, loadingSettings]);


    const loadExternalCss = (url: string) => {
        const linkId = 'dynamic-theme-css';
        let link = document.getElementById(linkId) as HTMLLinkElement | null;

        if (!link) {
            link = document.createElement('link');
            link.id = linkId;
            link.rel = 'stylesheet';
            link.type = 'text/css';
            document.head.appendChild(link);
        }

        if (link.href !== url) {
            link.href = url;
        }
    };

    // --- Back to Top Button Logic ---
    const handleScroll = useCallback(() => {
        if (window.scrollY > 300) { // Show button after scrolling 300px
            setShowBackToTop(true);
        } else {
            setShowBackToTop(false);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
    // --- End Back to Top Button Logic ---


    if (loadingSettings && !settings) {
        // return <footer className="footer z-40 sticky bottom-0 w-full">{t('footer.loadingTheme')}</footer>;
        return <footer className="footer fixed bottom-0 left-0 w-full z-40">{t('footer.loadingTheme')}</footer>;
    }

    return (
        <>
            {/* Add padding-bottom to your main content to prevent it from being hidden behind the fixed footer. Example: pb-20 */}
            {/* <footer className="footer sticky bottom-0 left-0 w-full z-40"> */}
            {/* Add padding-bottom to your main content to prevent it from being hidden behind the fixed footer. Example: pb-20 (or adjust based on footer height) */}
            <footer className="footer fixed bottom-0 left-0 w-full z-40">


                <div
                    id="nav-menu"
                    ref={menuRef}
                    className="hidden fixed bottom-16 right-0 h-3/4 w-4/5 bg-white border border-2 border-black  shadow-md p-4 slide-in-animation rounded-l-xl "
                    onMouseLeave={() => {
                        const menu = document.getElementById('nav-menu');
                        if (menu) {
                            menu.classList.add('slide-out-to-right');
                            menu.classList.remove('slide-in');
                        }
                    }}
                >
                    <button
                        onClick={() => {
                            const menu = document.getElementById('nav-menu');
                            if (menu) {
                                menu.classList.add('hidden');
                                menu.classList.remove('slide-in');
                            }
                        }}
                        className="absolute top-2 right-4 text-red-700"
                    >
                        {t('footer.close')}
                    </button>

                    {hasRole(['super_admin']) && (

                        <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 border border-green-500 rounded-md my-4 font-bold text-blue-700 bg-green-100">

                            <ul>
                                <li><Link to="/new-order" className="block md:inline-block mr-4 py-2 md:py-2  w-full hover:text-orange-600" >{t('footer.newOrderNote')} (Manual)</Link></li>
                                {/* <li><Link to="/new-order" className="block md:inline-block mr-4 py-2 md:py-2  w-full hover:text-orange-600" >{t('footer.newCreditNote')}</Link></li>
                                <li><Link to="/new-order" className="block md:inline-block mr-4 py-2 md:py-2  w-full hover:text-orange-600" >{t('footer.newDebitNote')}</Link></li>
                                <li><Link to="/new-order" className="block md:inline-block mr-4 py-2 md:py-2  w-full hover:text-orange-600" >{t('footer.newRefund')}</Link></li> */}

                                {isAdminOrStaff && (
                                    <li><Link to="/csv-uploader" className="block md:inline-block mr-4 py-2 md:py-2  w-full hover:text-orange-600" >[ BETA use for I.T. only: {t('footer.adminCsvUpload')} ]</Link></li>
                                )}
                            </ul>
                        </div>
                    )}

                    {hasRole(['super_admin', 'staff', 'technician']) && (

                        <div className="block px-4 py-2 text-sm text-gray-700 border border-green-500 rounded-md my-4 font-bold text-blue-700 bg-green-100 hover:bg-gray-100 ">

                            <ul>
                                <li><Link to="/stock-management" className=" block md:inline-block mr-4 px-16 py-2 md:py-2 w-full hover:text-orange-600" >{t('footer.stockManagement')}</Link></li>

                            </ul>
                        </div>
                    )}

                    {settings?.license_modules.includes('TaskReminder') && hasRole(['super_admin', 'staff', 'technician']) && (

                        <div className="block px-4 py-2 text-sm text-gray-700 border border-green-500 rounded-md my-4 font-bold text-blue-700 bg-green-100 hover:bg-gray-100 ">

                            <ul>
                                <li><Link to="/task-reminder" className=" block md:inline-block mr-4 px-16 py-2 md:py-2 w-full hover:text-orange-600" target='_blank' >{t('footer.taskReminders')}</Link></li>

                            </ul>
                        </div>
                    )}


                    {/* {hasRole(['super_admin']) && (

                        <div className="block px-4 py-2 text-sm text-gray-700 border border-green-500 rounded-md my-4 font-bold text-blue-700 bg-green-100 hover:bg-gray-100 ">

                            <ul>
                                <li><Link to="/myinvois/dashboard" className="block md:inline-block mr-4 px-16 py-2 md:py-2 hover:text-orange-600" >{t('footer.myInvois')}</Link></li>

                            </ul>
                        </div>
                    )} */}

                    <div className="block px-4 py-4 my-4 text-sm text-gray-700 bg-gray-50 hover:bg-gray-100 border border-gray-100 rounded-xl shadow">

                        <p className='font-bold'>{t('footer.officeAddress')}</p>
                        <br />

                        <p>
                            {settings?.address && settings.address.trim() !== '' && (
                                <>
                                    {settings.address}
                                </>
                            )}
                            {settings?.address_2 && settings.address_2.trim() !== '' && (
                                <>
                                    , {settings.address_2}
                                </>
                            )}
                            {settings?.address_3 && settings.address_3.trim() !== '' && (
                                <>
                                    , {settings.address_3}
                                </>
                            )}
                            {settings?.city && settings.city.trim() !== '' && (
                                <>
                                    , {settings.city}
                                </>
                            )}
                            {settings?.state && settings.state.trim() !== '' && (
                                <>
                                    , {settings.state}
                                </>
                            )}
                            {settings?.zipcode && settings.zipcode.trim() !== '' && (
                                <>
                                    , {settings.zipcode}
                                </>
                            )}
                            {settings?.country && settings.country.trim() !== '' && (
                                <>
                                    , {settings.country}
                                    <br />
                                </>
                            )}
                            {settings?.phone && settings.phone.trim() !== '' && (
                                <>
                                    <br />
                                    {t('footer.tel')} : {settings.phone}
                                    <br />
                                </>
                            )}
                        </p>
                    </div>

                    <div className="my-4 block px-4 py-4 text-sm text-gray-700 bg-green-100  border border-green-500 rounded-xl">
                        <a
                            href={`https://wa.me/${settings?.phone || '601112163808'}?text=${t('footer.whatsappEnquiryText', { companyName: settings?.shortname || 'u8.my' })}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block px-4 py-2 text-sm text-green-900  w-full hover:text-orange-600  animate-pulse border border-gray-200 rounded-md"
                        >
                            {t('footer.whatsappUs')}
                        </a>
                    </div>

                </div>

                {/* Quick Menu */}
                <div className="
            bg-neutral-50/90 hover:bg-neutral-100/90 
            text-green-600 backdrop-blur-[1px] border-t border-neutral-400/80 
            flex justify-around items-center p-2 md:visible rounded-t-xl">

                    <Link to="/" className="flex flex-col items-center">
                        <FaHome size={18} />
                        <span className="text-xs">{t('footer.home')}</span>
                    </Link>

                    <div className="relative">
                        <button
                            onClick={() => {
                                const menu = document.getElementById('nav-menu');
                                if (menu) {
                                    menu.classList.toggle('hidden');
                                    menu.classList.toggle('slide-in');
                                }
                            }}
                            className="flex flex-col items-center"
                        >
                            <FaBars size={18} />
                            <span className="text-xs">{t('footer.menu')}</span>
                        </button>

                    </div>

                    {isAuthenticated() && (
                        <>
                            <Link to="/order-history" className="flex flex-col items-center">
                                <FaHistory size={18} />
                                <span className="text-xs">{t('footer.orders')}</span>
                            </Link>
                            <Link to="/invoice-history" className="flex flex-col items-center">
                                <FaFileInvoiceDollar size={18} />
                                <span className="text-xs">{t('footer.receipts')}</span>
                            </Link>
                            <Link to="/cart" className="flex flex-col items-center">
                                <FaShoppingCart size={18} />
                                <span className="text-xs">{t('footer.cart')}</span>
                            </Link>
                        </>
                    )}


                    <a href={`https://wa.me/${settings?.phone || '601112163808'}?text=${t('footer.whatsappEnquiryText', { companyName: settings?.shortname || 'u8.my' })}`} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center">
                        <FaWhatsapp size={18} />
                        <span className="text-xs">{t('footer.whatsapp')}</span>
                    </a>
                </div>

                {/* Main Footer Content */}
                <div className="footer-copy-div">
                    <p>
                        {t('footer.copyright', {
                            year: new Date().getFullYear(),
                            companyName: window.APP_CONFIG?.REACT_APP_COMPANY_NAME,
                            fqdn: fqdn,
                            developerName: "Boyd Chung"
                        })}
                    </p>
                </div>
                {showBackToTop && (
                    <button
                        onClick={scrollToTop}
                        className="fixed bottom-20 right-0 

                    bg-green-900/60 hover:bg-blue-900/60  text-black  backdrop-blur-[1px] border border-neutral-400/20


                    text-white font-bold py-2 px-3 rounded-full shadow-lg transition-opacity duration-300 z-40 "
                        title="Back to Top"
                        aria-label="Back to Top"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-5" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v10.586l3.293-3.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z" clipRule="evenodd" transform="rotate(180 10 10)" />
                        </svg>
                    </button>
                )}
            </footer>
        </>
    );
};

export default Footer;
